import React from "react";
import { BRAND } from "../lib/brand";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[color:var(--dbe-cream)] text-neutral-800 border-t border-neutral-200">
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[color:var(--dbe-red)] via-[color:var(--dbe-gold)] to-[color:var(--dbe-red)]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 pt-14 sm:pt-20 pb-8 sm:pb-10 grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
        <div className="md:col-span-2">
          <img src={BRAND.logo} alt={BRAND.name} className="h-14 sm:h-16 rounded-sm bg-white p-1 border border-neutral-200" />
          <p className="mt-4 sm:mt-5 text-sm sm:text-base text-neutral-600 max-w-md leading-relaxed">
            South Florida's most trusted name in termite and pest control since {BRAND.since}.
            Family-rooted, results-driven, and still answering the phone like it's 1959.
          </p>
          <a
            href={`tel:${BRAND.phoneTel}`}
            data-testid="footer-call-cta"
            className="mt-5 sm:mt-6 inline-flex items-center gap-3 bg-[color:var(--dbe-red)] hover:bg-[color:var(--dbe-red-deep)] text-white px-5 sm:px-6 py-3 rounded-full font-bebas text-xl sm:text-2xl tracking-wider shadow-[0_15px_35px_-15px_rgba(227,30,36,0.6)]"
          >
            <Phone className="w-5 h-5" /> {BRAND.phoneDisplay}
          </a>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[color:var(--dbe-red)] font-bold mb-5">Company</h4>
          <ul className="space-y-3 text-neutral-700">
            <li><Link to="/about-us" className="hover:text-[color:var(--dbe-red)]" data-testid="footer-link-about">About Us</Link></li>
            <li><a href="#services" className="hover:text-[color:var(--dbe-red)]" data-testid="footer-link-services">Services</a></li>
            <li><a href="#why" className="hover:text-[color:var(--dbe-red)]" data-testid="footer-link-why">Why Choose Us</a></li>
            <li><a href="#reviews" className="hover:text-[color:var(--dbe-red)]" data-testid="footer-link-reviews">Reviews</a></li>
            <li><a href="#quote" className="hover:text-[color:var(--dbe-red)]" data-testid="footer-link-quote">Free Estimate</a></li>
            <li>
              <Link to="/accessibility-statement" className="hover:text-[color:var(--dbe-red)]" data-testid="footer-link-accessibility">
                Accessibility Statement
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[color:var(--dbe-red)] font-bold mb-5">Contact</h4>
          <ul className="space-y-3 text-neutral-700">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[color:var(--dbe-red)] flex-shrink-0" />
              <span>{BRAND.address.line1}<br/>{BRAND.address.city}, {BRAND.address.state} {BRAND.address.zip}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[color:var(--dbe-red)] flex-shrink-0" />
              <a href={`tel:${BRAND.phoneTel}`} className="hover:text-[color:var(--dbe-red)]">{BRAND.phoneDisplay}</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[color:var(--dbe-red)] flex-shrink-0" />
              <a href={`tel:${BRAND.officePhoneTel}`} className="hover:text-[color:var(--dbe-red)]">{BRAND.officePhoneDisplay}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[color:var(--dbe-red)] flex-shrink-0" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[color:var(--dbe-red)]">{BRAND.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-[color:var(--dbe-red)] flex-shrink-0" />
              <span>{BRAND.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 py-5 sm:py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs sm:text-sm text-neutral-600 text-center md:text-left">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p data-testid="brand-partners-credit">
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="brand-partners-link"
              className="font-bold text-neutral-900 hover:text-[color:var(--dbe-red)] underline underline-offset-4 decoration-[color:var(--dbe-red)]"
            >
              Brand Partners
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
